import React, { useEffect, useState } from 'react';
import { Link, Outlet, useParams } from 'react-router-dom';
import axios from 'axios';
import APIEndPoints from '../../../../middleware/APIEndPoints';

const EditProject = () => {
  const { projectId } = useParams(); // Get projectId from URL
  const [projectData, setProjectData] = useState({
    title: '',
    category: '',
    description: '',
    githubLink: ''
  });

  const baseURL = APIEndPoints.myprojects.url;

  // Fetch project details by ID when component loads
  useEffect(() => {
    const fetchProject = async () => {
      try {
        const response = await axios.get(`${baseURL}/${projectId}`);
        setProjectData(response.data); // Set the project details in state
      } catch (err) {
        console.error('Error fetching project details:', err);
      }
    };

    fetchProject();
  }, [projectId]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setProjectData({ ...projectData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.put(`${baseURL}/${projectId}`, projectData);
      alert('Project updated successfully!');
    } catch (err) {
      console.error('Error updating project:', err);
      alert('Failed to update project.');
    }
  };

  return (
    <div className="bg-[#1d0c39] min-h-screen p-6 text-white">
      <h1 className="text-2xl font-bold mb-6">Edit Project</h1>
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label htmlFor="title">Project Title:</label>
          <input
            type="text"
            id="title"
            name="title"
            value={projectData.title}
            onChange={handleInputChange}
            className="w-full p-2 mt-2 rounded bg-gray-800 text-white"
            required
          />
        </div>

        <div>
          <label htmlFor="category">Project Category:</label>
          <input
            type="text"
            id="category"
            name="category"
            value={projectData.category}
            onChange={handleInputChange}
            className="w-full p-2 mt-2 rounded bg-gray-800 text-white"
            required
          />
        </div>

        <div>
          <label htmlFor="description">Project Description:</label>
          <textarea
            id="description"
            name="description"
            value={projectData.description}
            onChange={handleInputChange}
            className="w-full p-2 mt-2 rounded bg-gray-800 text-white"
            required
          />
        </div>

        <div>
          <label htmlFor="githubLink">GitHub Link:</label>
          <input
            type="url"
            id="githubLink"
            name="githubLink"
            value={projectData.githubLink}
            onChange={handleInputChange}
            className="w-full p-2 mt-2 rounded bg-gray-800 text-white"
            required
          />
        </div>


        <button type="submit" className="bg-green-600 p-2 rounded w-full mt-6 hover:bg-green-700">
          Update Project
        </button>
        {/* Buttons for managing image and video */}
        <div className="flex mt-4">
          <Link to='images'>images
          </Link>
          <Link to='videos'>videos
          </Link>
        </div>
        <div>
          <Outlet />

        </div>
      </form>
    </div>
  );
};

export default EditProject;
